<template>
  <div class="modal">
    <button
      class="modal__close"
      @click="$emit('close')"
    >
      <SvgAsset
        class="modal__close-icon"
        :content="crossMobilePath"
      />
    </button>
    <div class="modal__body">
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
  import SvgAsset from '@devhacker/shared/components/SvgAsset.vue';
  import crossMobilePath from '@/assets/images/svg/cross--mobile.svg?raw';

  export default defineNuxtComponent({
    name: 'TestModal',

    components: { SvgAsset },

    computed: {
      crossMobilePath: () => crossMobilePath,
    },
  });
</script>

<style lang="scss" scoped>
  .modal {
    width: 100%;
    height: 100%;
    background: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
    padding: $spacing-4;

    @include tablet {
      padding: $spacing-16 $spacing-15;
      border: 1px solid $border-color--1;
      width: 100%;
      height: unset;
      border-radius: 32px;
    }
    @include big-tablet {
      position: relative;
    }

    &__close {
      position: absolute;
      top: $spacing-4;
      right: $spacing-4;
      width: 24px;
      height: 24px;
    }

    &__close-icon {
      width: 100%;
      height: 100%;
      transition: 0.2s all ease-in;
      :deep() {
        svg path {
          fill: #969698;
        }
      }

      @include hover {
        :deep() {
          svg path {
            fill: #000000;
          }
        }
      }
    }

    &__body {
      width: 100%;
    }
  }
</style>
